"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makePhrasesPlaceholderFunc = void 0;
const I18nNotInitializedError_1 = require("./I18nNotInitializedError");
const makePhrasesPlaceholderFunc = (i18nInstance, lng) => {
    return (key, options) => {
        if (!i18nInstance.isInitialized)
            throw new I18nNotInitializedError_1.I18nNotInitializedError();
        return i18nInstance.t(key, { ...options, lng });
    };
};
exports.makePhrasesPlaceholderFunc = makePhrasesPlaceholderFunc;
//# sourceMappingURL=makePhrasesPlaceholderFunc.js.map